import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as DefaultHeader } from '../../icon/default-header.svg'
import { ReactComponent as Exclamation } from '../../icon/exclamation.svg'
import "../../css/PageNotFound.css"
import BobbingIcon from '../common/BobbingIcon'

interface PageNotFoundProps {
  error?: string | null
}

function PageNotFound({ error }: PageNotFoundProps) {
  const { t } = useTranslation()

  return (
    <div className="pageNotFoundContainer">
      <div>
        <a href="https://www.simplebooth.com" target="_top">
          <DefaultHeader className="logo" />
        </a>
      </div>

      <BobbingIcon horizontalOffset="-23px" verticalOffset="-20px">
          <Exclamation />
      </BobbingIcon>

      <h1>{t("pageNotFound.heading")} <span role="img" aria-label="Sad face">😔</span></h1>
      {error &&
        <p>({error})</p>
      }
    </div>
  )
}

export default PageNotFound
